import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpclienterrorService } from '../interceptor/httpclienterror.service';
import { environment } from 'src/environments/environment';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranquilidadeService {
  constructor(
    private http: HttpClient,
    public httpclienterrorService: HttpclienterrorService,
  ) {}

  TranquilidadedownloadObterDocumentoRecibo(
    NrRecibo: string,
    ValorRecibo: string,
    NrApolice: string,
    Tipo: string,
  ): Observable<Blob> {
    if (NrRecibo === null || NrRecibo.trim() === '') {
      return throwError(() => new Error('NrRecibo inválido.')); // Usando uma função de fábrica para criar o erro
    }

    let dados = {
      NrRecibo: NrRecibo,
      ValorRecibo: ValorRecibo,
      NrApolice: NrApolice,
      Tipo: Tipo,
    };

    return this.http
      .post(environment.URLROBOT + `/tranquilidade/ObterDocumentoRecibo`, dados, {
        responseType: 'blob', // Define o tipo de resposta como blob
      })
      .pipe(
        catchError((error: any) => {
          return throwError(() => error); // Captura e repassa o erro caso ocorra algum durante a chamada HTTP
        }),
      );
  }

  TranquilidadedownloadObterDocumentoCartaVerde(
    NrRecibo: string,
    NrApolice: string,
    Matricula: string,
  ): Observable<Blob> {
    if (NrRecibo === null || NrRecibo.trim() === '') {
      return throwError(() => new Error('NrRecibo inválido.')); // Usando uma função de fábrica para criar o erro
    }

    let dados = {
      NrRecibo: NrRecibo,
      NrApolice: NrApolice,
      Matricula: Matricula,
    };

    return this.http
      .post(environment.URLROBOT + `/tranquilidade/ObterDocumentoCartaVerde`, dados, {
        responseType: 'blob', // Define o tipo de resposta como blob
      })
      .pipe(
        catchError((error: any) => {
          return throwError(() => error); // Captura e repassa o erro caso ocorra algum durante a chamada HTTP
        }),
      );
  }

  SyncPolicy(policyNumber: string): Observable<any> {
    return this.http.get(environment.URLROBOT + `/tranquilidade/sync-policy/${policyNumber}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetPolicyRawData(policyNumber: string): Observable<any> {
    return this.http.get(environment.URLROBOT + `/tranquilidade/get-policy-raw-data/${policyNumber}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }
}
